import { render, staticRenderFns } from "./comBox.vue?vue&type=template&id=7e1177a5&"
import script from "./comBox.vue?vue&type=script&lang=js&"
export * from "./comBox.vue?vue&type=script&lang=js&"
import style0 from "./comBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports